export enum DiscountVisibilityEmum {
  AUTOMATIC = "AUTOMATIC",
  MANUAL = "MANUAL",
  HIDDEN = "HIDDEN",
}
